import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { workingStart, workingEnd } from 'wfui-digital-core/es/actions';
import { showStopMessage } from '../../../../../lib/store/stop-message/actions';
import { requestNavigation } from '../../../../../lib/store/navigation/actions';
import { closeGlobalSearch } from '../../../../../lib/store/global-search/actions';
import logger from '../../../../../lib/logger/logger';
import postForm from '../../../../../lib/network/post-form';
import getNavigationItem from '../get-navigation-item/get-navigation-item';

function navigate(_x) {
  return _navigate.apply(this, arguments);
}

function _navigate() {
  _navigate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var reduxDispatch, identifier, wwwUrl, ctaUrl, getString, _yield$postForm, result, FailureMessageBean, globalMessages, message;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reduxDispatch = _ref.reduxDispatch, identifier = _ref.identifier, wwwUrl = _ref.wwwUrl, ctaUrl = _ref.ctaUrl, getString = _ref.getString;
            _context.prev = 1;
            reduxDispatch(workingStart({
              showSpinner: true
            }));
            _context.next = 5;
            return postForm({
              url: ctaUrl,
              includeRootContext: false,
              data: {
                identifier: identifier,
                wwwUrl: wwwUrl
              }
            });

          case 5:
            _yield$postForm = _context.sent;
            result = _yield$postForm.linkNavigationViewBean;
            reduxDispatch(requestNavigation(getNavigationItem(result)));
            _context.next = 17;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            logger.error('Failed to navigate from search results', _context.t0.FailureMessageBean);
            FailureMessageBean = _context.t0.FailureMessageBean || {};
            globalMessages = FailureMessageBean.globalMessages || [{}];
            message = globalMessages[0].message || getString('globalSearch.system.unavailable');
            reduxDispatch(showStopMessage(message));

          case 17:
            _context.prev = 17;
            reduxDispatch(closeGlobalSearch());
            reduxDispatch(workingEnd());
            return _context.finish(17);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10, 17, 21]]);
  }));
  return _navigate.apply(this, arguments);
}

export default navigate;